import styled from 'styled-components'
import Button from './Button'
import { soloTextLink } from '../styles/textLink'

const SectionIntro = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  margin-left: var( --grid-parent-gutter );
  margin-right: var( --grid-parent-gutter );

  > * {
    margin: 0;
    margin-left: var( --grid-child-gutter );
    margin-right: var( --grid-child-gutter );
  }

  @media ( min-width: 800px ) {
    grid-template-columns: calc( ( 2 / 10 ) * 100% ) calc( ( 8 / 10 ) * 100% );

    > *.hod-grid-2-3 {
      grid-column: 2 / 3;
    }
  }
  
  @media ( min-width: 1000px ) {
    grid-template-columns: calc( ( 2 / 10 ) * 100% ) calc( ( 7 / 10 ) * 100% );
  }

  @media ( min-width: 1250px ) {
    grid-template-columns: calc( ( 2 / 10 ) * 100% ) calc( ( 6 / 10 ) * 100% );
  }

  h2 {
    ${ p => p.theme.typo.neueHaasBold }
    font-size: ${ p => p.theme.typo.sizes.medium };
  }

  p {
    margin: 1rem 0;

    &:first-child {
      margin-top: 0;
    }
    
    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    color: inherit;
    text-decoration-color: ${ p => p.theme.colors.highlight };
  }

  > a,
  p a:only-child {
    ${ soloTextLink }
  }

  ${ Button } {
    font-size: ${ p => p.theme.typo.sizes.dropped };
  }
`

export const SectionIntroHTML = styled.div`
  margin: 1rem 0;

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }

  > a {
    ${ soloTextLink }
  }
`

export default SectionIntro
